import styled, { css } from 'styled-components';
import { Colors } from 'styles/Constants';

export interface EditorWrapperProps {
  disabled?: boolean;
}

export const EditorWrapper = styled.div<EditorWrapperProps>`
  user-select: text;
  border: 1px solid #e2e3e5;
  padding: 5px;
  border-radius: 4px;
  position: relative;
  box-shadow: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.7;
  min-height: 200px;
  min-width: 80%;
  background-color: ${({ disabled }) => (disabled ? '#f5f6f8' : '#FFFFFF')};
  transition: border-color 0.3s ease;

  &.over-limit {
    border-color: #ff303f;
    box-shadow: 0 0 0 1px #ff303f;
  }

  .public-DraftEditorPlaceholder-inner {
    color: ${Colors.placeholder};
    opacity: 0.6;
  }

  .DraftEditor-editorContainer,
  .DraftEditor-root,
  .public-DraftEditor-content {
    user-select: text;
    min-height: 180px;
    padding: 4px;
    outline: none;
  }

  span[data-text='true'] {
    user-select: text;
    pointer-events: all;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.8;
      background-color: ${Colors.disabled};
    `}
`;

export const StyledCounter = styled.span`
  position: absolute;
  font-size: 12px;
  right: 12px;
  bottom: 8px;
  background-color: #e2e3e5;
  padding: 2px 6px;
  border-radius: 12px;
  font-family: monospace;
  transition: all 0.3s ease;

  /* Estado normal */
  &.max-chars-ok {
    color: ${Colors.textSecondary};
    background-color: #e2e3e5};
  }

  /* Advertencia (cerca del límite) */
  &.max-chars-warning {
    color: #Fff;
    background-color: #ff991f;
    border: 1px solid #Fff;
  }

  /* Error (límite excedido) */
  &.max-chars-error {
    color: #fff;
    background-color: #ff303f;
    font-weight: bold;
    border: 1px solid #Fff;
  }
`;

export const Hashtag = styled.span`
  color: ${Colors.primaryDarkBlue};
  font-weight: bold;
  cursor: pointer;
`;

export const Url = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer'
})`
  color: ${Colors.primaryDarkBlue};
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${Colors.primaryBlue};
  }
`;

export const Mention = styled(Hashtag)`
  direction: ltr;
  unicode-bidi: bidi-override;
`;
